module.exports = __webpack_public_path__ + "img/logo.ba79ff25.png";